import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

const CountdownText = observer(
    ({
        startTime,
        className,
    }: {
        /**
         * 시작 시간: YYYY-MM-DD HH:mm:ss 형식의 문자열
         */
        startTime: string | null | undefined;
        className?: string;
    }) => {
        const startTimeDayjs = useMemo(() => {
            if (!startTime) {
                return null;
            }

            return dayjs(startTime);
        }, [startTime]);

        const [hours, setHours] = useState(0);
        const [minutes, setMinutes] = useState(0);
        const [seconds, setSeconds] = useState(0);

        const timerRef = useRef<NodeJS.Timeout | null>(null);

        useEffect(() => {
            if (!startTimeDayjs) {
                clearTimeout(timerRef.current!);
                return;
            }

            const updateTime = () => {
                const now = dayjs();

                const diff = now.diff(startTimeDayjs, 'seconds');

                const hours = Math.floor(diff / 3600);
                const minutes = Math.floor((diff % 3600) / 60);
                const seconds = diff % 60;

                setHours(hours);
                setMinutes(minutes);
                setSeconds(seconds);

                timerRef.current = setTimeout(updateTime, 1000);
            };

            updateTime();

            return () => {
                clearTimeout(timerRef.current!);
            };
        }, [startTimeDayjs]);

        return (
            <div className={twMerge('inline-flex items-center gap-1', className)}>
                {hours > 0 && (
                    <div className="countdown tabular-nums">
                        <span
                            style={
                                {
                                    '--value': hours,
                                } as React.CSSProperties
                            }
                        >
                            {hours}
                        </span>
                        시간
                    </div>
                )}
                {minutes > 0 && (
                    <div className="countdown tabular-nums">
                        <span
                            style={
                                {
                                    '--value': minutes,
                                } as React.CSSProperties
                            }
                        >
                            {minutes}
                        </span>
                        분
                    </div>
                )}
                {seconds > 0 && (
                    <div className="countdown tabular-nums">
                        <span
                            style={
                                {
                                    '--value': seconds,
                                } as React.CSSProperties
                            }
                        >
                            {seconds}
                        </span>
                        초
                    </div>
                )}
            </div>
        );
    },
);

export default CountdownText;
